/* Shows the shopper's most recently saved Designer logo on customizable archive cards. */
(function () {
  'use strict';

  if (window.KSArchiveDesignerLogo && typeof window.KSArchiveDesignerLogo.refresh === 'function') {
    window.KSArchiveDesignerLogo.refresh();
    return;
  }

  var STORAGE_KEY = 'ks-designer-latest-logo';
  var BADGE_SELECTOR = '[data-ks-custom-logo-badge]';
  var checkedLogo = false;
  var savedLogoSource = '';
  var observing = false;
  var refreshQueued = false;
  var designerAvailability = {};
  var badgeObserver = null;

  function designerEnabled(productId) {
    if (!productId) return Promise.resolve(false);
    if (designerAvailability[productId]) return designerAvailability[productId];

    designerAvailability[productId] = fetch('/apps/ks-designer/config?productId=' + encodeURIComponent(productId), {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) return false;
      return response.json().then(function (payload) {
        var views = payload && payload.config && Array.isArray(payload.config.views) ? payload.config.views : [];
        return views.some(function (view) {
          var placements = Array.isArray(view.logoPlacements) ? view.logoPlacements : [];
          var layers = Array.isArray(view.layers) ? view.layers : [];
          return placements.length > 0 || layers.some(function (layer) {
            return layer && (layer.uploadZone === true || layer.customerEditable === true);
          });
        });
      });
    }).catch(function () { return false; });

    return designerAvailability[productId];
  }

  function checkBadge(badge) {
    if (!badge || badge.dataset.ksDesignerChecked === 'true' || badge.dataset.ksDesignerChecking === 'true') return;
    badge.dataset.ksDesignerChecking = 'true';
    designerEnabled(String(badge.dataset.ksDesignerProductId || '')).then(function (enabled) {
      badge.dataset.ksDesignerChecking = 'false';
      badge.dataset.ksDesignerChecked = 'true';
      badge.hidden = !enabled;
      if (enabled) updateBadges(savedLogoSource);
    });
  }

  function verifyBadges() {
    if (!badgeObserver && 'IntersectionObserver' in window) {
      badgeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          badgeObserver.unobserve(entry.target);
          entry.target.dataset.ksDesignerObserved = 'false';
          checkBadge(entry.target);
        });
      }, { rootMargin: '300px 0px' });
    }

    document.querySelectorAll(BADGE_SELECTOR).forEach(function (badge) {
      if (badge.dataset.ksDesignerChecked === 'true' || badge.dataset.ksDesignerChecking === 'true') return;
      if (!badgeObserver) {
        checkBadge(badge);
        return;
      }
      if (badge.dataset.ksDesignerObserved === 'true') return;
      badge.dataset.ksDesignerObserved = 'true';
      badgeObserver.observe(badge);
    });
  }

  function usableSource(value) {
    if (typeof value !== 'string' || !/^data:image\/(?:png|jpe?g|webp);base64,/i.test(value)) return '';
    return value.length <= 15000000 ? value : '';
  }

  function storedLogoSource() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      return usableSource(stored && (stored.previewSource || stored.source));
    } catch (error) {
      return '';
    }
  }

  function loadSavedLogo() {
    return new Promise(function (resolve) {
      var fallback = storedLogoSource();
      if (!window.indexedDB) {
        resolve(fallback);
        return;
      }

      var request;
      try {
        request = window.indexedDB.open('ks-designer-library', 1);
      } catch (error) {
        resolve(fallback);
        return;
      }

      request.onerror = function () { resolve(fallback); };
      request.onupgradeneeded = function () { resolve(fallback); };
      request.onsuccess = function () {
        var database = request.result;
        if (!database.objectStoreNames.contains('assets')) {
          database.close();
          resolve(fallback);
          return;
        }

        var getRequest;
        try {
          getRequest = database.transaction('assets', 'readonly').objectStore('assets').get('latest-logo');
        } catch (error) {
          database.close();
          resolve(fallback);
          return;
        }

        getRequest.onerror = function () {
          database.close();
          resolve(fallback);
        };
        getRequest.onsuccess = function () {
          var logo = getRequest.result;
          database.close();
          resolve(usableSource(logo && (logo.previewSource || logo.source)) || fallback);
        };
      };
    });
  }

  function updateBadges(source) {
    document.querySelectorAll(BADGE_SELECTOR).forEach(function (badge) {
      var image = badge.querySelector('[data-ks-custom-logo-preview]');
      var icon = badge.querySelector('[data-ks-custom-logo-icon]');
      var label = badge.querySelector('[data-ks-custom-logo-label]');
      if (!image || !icon || !label) return;

      if (!source) {
        image.removeAttribute('src');
        if (!image.hidden) image.hidden = true;
        if (icon.hidden) icon.hidden = false;
        if (label.textContent !== 'Add Your Logo') label.textContent = 'Add Your Logo';
        return;
      }

      image.onload = function () {
        if (image.hidden) image.hidden = false;
        if (!icon.hidden) icon.hidden = true;
        if (label.textContent !== 'Edit Your Logo') label.textContent = 'Edit Your Logo';
      };
      image.onerror = function () {
        image.removeAttribute('src');
        if (!image.hidden) image.hidden = true;
        if (icon.hidden) icon.hidden = false;
        if (label.textContent !== 'Add Your Logo') label.textContent = 'Add Your Logo';
      };
      if (image.getAttribute('src') !== source) image.src = source;
    });
  }

  function refreshBadges() {
    verifyBadges();
    if (checkedLogo) {
      updateBadges(savedLogoSource);
      return;
    }

    checkedLogo = true;
    loadSavedLogo().then(function (source) {
      savedLogoSource = source;
      updateBadges(source);
    });
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    window.setTimeout(function () {
      refreshQueued = false;
      refreshBadges();
    }, 0);
  }

  function start() {
    refreshBadges();
    if (observing || !document.body || !window.MutationObserver) return;
    observing = true;
    new MutationObserver(queueRefresh).observe(document.body, { childList: true, subtree: true });
  }

  window.KSArchiveDesignerLogo = { refresh: queueRefresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
